export function jsonParse<T = unknown>(text: string, defaultValue?: T): T {
    try {
        return typeof text === 'string' ? JSON.parse(text) as T : defaultValue;
    } catch {
        return defaultValue;
    }
}
